import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Toggle } from '../ui/Toggle';
import { Modal } from '../ui/Modal';

export interface NewMember {
  name: string;
  isVegetarian: boolean;
  drinksAlcohol: boolean;
}

interface QuickAddMemberProps {
  isOpen: boolean;
  onClose: () => void;
  onAdd: (member: NewMember) => void;
}

export const QuickAddMember: React.FC<QuickAddMemberProps> = ({
  isOpen,
  onClose,
  onAdd,
}) => {
  const [name, setName] = useState('');
  const [isVegetarian, setIsVegetarian] = useState(false);
  const [drinksAlcohol, setDrinksAlcohol] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;

    onAdd({
      name: name.trim(),
      isVegetarian,
      drinksAlcohol,
    });

    // Reset form
    setName('');
    setIsVegetarian(false);
    setDrinksAlcohol(false);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add Person">
      <form onSubmit={handleSubmit} className="space-y-6">
        <Input
          label="Name"
          placeholder="Enter name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoFocus
        />

        <div className="space-y-4">
          <p className="text-sm font-medium text-slate-700">Dietary Preferences</p>

          <div className="space-y-3 p-4 bg-slate-50 rounded-xl">
            <Toggle
              checked={isVegetarian}
              onChange={setIsVegetarian}
              label="Vegetarian"
              description="Doesn't eat meat or fish"
            />

            <div className="border-t border-slate-200 pt-3">
              <Toggle
                checked={drinksAlcohol}
                onChange={setDrinksAlcohol}
                label="Drinks Alcohol"
                description="Include in alcohol split"
              />
            </div>
          </div>
        </div>

        <div className="flex gap-3">
          <Button type="button" variant="secondary" onClick={onClose} fullWidth>
            Cancel
          </Button>
          <Button type="submit" fullWidth disabled={!name.trim()}>
            Add Person
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default QuickAddMember;
